import React from "react";
import { useParams } from "react-router-dom";
import { Card, Box, Typography, Tabs, Tab } from "@mui/material";
import useClientDetails from "../../../../../hooks/useClientDetails";
import AbbeyPainScale from "./AbbeyPainScale/AbbeyPainScale";
import CapabilityAssessment from "./Capability/CapabilityAssessment";
import ChokingAssessment from "./Chocking/ChockingAssessment";
import CornellDepressionScale from "./CornelDepression/CornelDepression";
import GeriatricDepressionScale from "./GeriatricDepressionScale/GeriatricDepressionScale";
import FallsRiskAssessment from "./FallsRiskAssessment/FallsRiskAssessment";
import FireRiskAssessment from "./FireRiskAssessment/FireRiskAssessment";
import InitialOralHealthAssessment from "./InitialOralHealth/InitialOralHealthAssessment";
import BedRailAssessment from "../BedRailAssessments/BedRailAssessment";

const ClientAssessment = () => {
  const { id: clientID } = useParams();
  const { fullName } = useClientDetails(clientID);

  const initialTab = window.location.hash
    ? window.location.hash.substring(1)
    : "abbey-pain-scale";
  const [activeTab, setActiveTab] = React.useState(initialTab);

  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
    window.location.hash = newValue;
  };

  React.useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash) setActiveTab(hash);
    };
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <Card sx={{ mb: 3 }}>
        <Box sx={{ bgcolor: "primary.main", color: "white", p: 2 }}>
          <Typography variant="h5" fontWeight="bold">
            {fullName} - Client Assessments
          </Typography>
        </Box>
      </Card>

      <Card sx={{ py: 2, width: "100%" }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: "divider", maxWidth: "1600px" }}
        >
          <Tab label="Abbey Pain Scale Tool" value="abbey-pain-scale" />
          <Tab label="Bed Rail Assessment" value="bed-rail-assessment" />
          <Tab label="Capability Assessment" value="capability-assessment" />
          <Tab label="Choking Risk Assessment" value="choking-risk" />
          <Tab label="Cornell Depression Scale" value="cornell-depression" />
          <Tab label="COVID-19 Best Interest" value="covid-best-interest" />
          <Tab label="Geriatric Depression Scale" value="depression-scale" />
          <Tab label="Falls Tool" value="falls-tool" />
          <Tab label="Fire Risk Assessment" value="fire-risk" />
          <Tab label="Initial Oral Health" value="oral-health" />
          <Tab label="Mouth Care Assessment" value="mouth-care" />
          <Tab label="Moving and Handling" value="moving-handling" />
          <Tab label="MUAC Nutritional Risk" value="muac-risk" />
          <Tab label="Evacuation Plan" value="evacuation-plan" />
          <Tab label="UTI Assessment" value="uti-assessment" />
          <Tab
            label="Waterlow Pressure Tool"
            value="waterlow-risk-assessment"
          />
          <Tab label="Well-Being Assessment" value="wellbeing-assessment" />
        </Tabs>

        <Box sx={{ mt: 2, minHeight: "500px" }}>
          {activeTab === "abbey-pain-scale" && <AbbeyPainScale />}
          {activeTab === "bed-rail-assessment" && <BedRailAssessment />}
          {activeTab === "capability-assessment" && <CapabilityAssessment />}
          {activeTab === "choking-risk" && <ChokingAssessment />}
          {activeTab === "cornell-depression" && <CornellDepressionScale />}
          {activeTab === "covid-best-interest" && (
            <div>COVID-19 Best Interest Checklist</div>
          )}
          {activeTab === "depression-scale" && <GeriatricDepressionScale />}
          {activeTab === "falls-tool" && <FallsRiskAssessment />}
          {activeTab === "fire-risk" && <FireRiskAssessment />}
          {activeTab === "oral-health" && <InitialOralHealthAssessment />}
          {activeTab === "mouth-care" && (
            <div>Mouth Care Assessment and Record</div>
          )}
          {activeTab === "moving-handling" && <div>Moving and Handling</div>}
          {activeTab === "muac-risk" && <div>Nutritional Risk using MUAC</div>}
          {activeTab === "evacuation-plan" && (
            <div>Personal Emergency Evacuation Plan</div>
          )}
          {activeTab === "uti-assessment" && (
            <div>Suspected UTI Assessment</div>
          )}
          {activeTab === "waterlow-risk-assessment" && (
            <div>Waterlow Pressure Tool</div>
          )}
          {activeTab === "wellbeing-assessment" && (
            <div>Well-Being Assessment Tool</div>
          )}
        </Box>
      </Card>
    </Box>
  );
};

export default ClientAssessment;
